import {MdModeEditOutline, MdDeleteOutline} from "react-icons/md";

const TableCustomers = ({
  tableData,
  detailData,
  editRow,
  deleteRow,
  currentPage,
}) => {
  let startNumber = 1;

  if (currentPage !== 1) {
    startNumber = (currentPage - 1) * 9 + 1;
  }

  const capitalizeEachWord = (sentence) => {
    const words = sentence.split(" ");
    for (let i = 0; i < words.length; i++) {
      words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }

    return words.join(" ");
  };
  return (
    <table className="font-nunito-sans text-xs w-full overflow-y-auto relative">
      <thead className="sticky top-0">
        <tr className="bg-[#F9F9FC] text-black text-left">
          <th className="p-2 text-center whitespace-nowrap">No</th>
          <th className="p-2 whitespace-nowrap">Customers Id</th>
          <th className="p-2 text-center whitespace-nowrap">Birthday</th>
          <th className="p-2 whitespace-nowrap">Name</th>
          <th className="p-2 whitespace-nowrap">Phone Number</th>
          <th className="p-2 text-center whitespace-nowrap">Membership</th>
          <th className="p-2 text-center whitespace-nowrap">Action</th>
        </tr>
      </thead>
      <tbody>
        {tableData.length > 0 &&
          tableData.map((row) => (
            <tr key={row.id} className="even:bg-[#F9F9FC] text-black">
              <td className="p-4 text-center whitespace-nowrap">{startNumber++}</td>
              <td className="p-2 whitespace-nowrap">{row.code}</td>
              <td className="p-2 text-center whitespace-nowrap">{row.birthday}</td>
              <td className="p-2 whitespace-nowrap">{row.name}</td>
              <td className="p-2 whitespace-nowrap">{row.phone}</td>
              <td className="p-2 text-center whitespace-nowrap">
                {row.membership === "vip"
                  ? row.membership.toUpperCase()
                  : capitalizeEachWord(row.membership)}
              </td>
              <td className="p-2 flex justify-center whitespace-nowrap">
                <button
                  onClick={() => {
                    editRow(row.id);
                  }}
                >
                  <MdModeEditOutline className="text-red-500 hover:text-red-800" />
                </button>
                <button onClick={() => deleteRow(row.id)}>
                  <MdDeleteOutline className="ml-2 text-red-500 hover:text-red-800" />
                </button>
                <button
                  className="ml-2 px-3 py-2 bg-blue-100 hover:bg-blue-400 rounded-lg mr-2"
                  onClick={() => detailData(row.id)}
                >
                  See Detail
                </button>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default TableCustomers;
